import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Homepage from './Home/index'
import ChatUi from './ChatUi/index'
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, HashRouter, Navigate, Route, Routes} from 'react-router-dom'
import Login_page_ad from './Login/index'
import Dadmin from './Admin/index'
import Useradmin_ui from "./Useradmin/Index";
import Project_Index_UI from "./Project";
import Project_projectmanagement from "./Project/Project_projectmanagement";
import Project_LoginForm from "./Project/Login";
import Admin_Index_UI from "./Admin/index";
import Admin_chatmagin from "./Admin/Admin_chatmagin";
import Admin_setting from "./Admin/Admin_setting";
import ClientUpdatePublisher from "./Admin/ClientUpdatePublisher";
import Admin_keyclick from "./Admin/Admin_keyclick";
import SuperAdminUsers from "./Admin/SuperAdminUsers";
import AccountUsage from "./Admin/AccountUsage";
import Knowledge_base from "./Admin/Admin_knowledge_base.php";
import Admin_Commodity_ui from "./Admin/Admin_commodity";
import Commodity_fenlei_UI from "./Admin/Commodity_info/Commodity_fenlei";
import Commodity_list_UI from "./Admin/Commodity_info/Commodity_list";
import Knowledge_detail from "./Admin/knowledge_detail";
import Home_item1_UI from "./Home/Home_item1";
import Home_soft_download from "./Home/Home_soft_download";
import Project_downloadmanagement from "./Project/Project_downloadmanagement";
import Register_index_ui from "./register";
import Project_setting from "./Project/Project_setting";
import Search_ui_index from "./Admin/Admin_search";
import UserInfo_UI from "./Admin/UserInfo";
import BuyVip_ui from "./Admin/BuyVip";
import VipRedemption_UI from "./Admin/VipRedemption";
import Project_vipcard from "./Project/Project_vipcard";
import Admin_moban_ui from "./Admin/Admin_moban";
import SearchChain from "./Admin/Admin_kuai_message";
import Employeemanage_Index_UI from "./Employeemanage";
import Employeemanage_SearchChain from "./Employeemanage/kuai_message";
import Employeemanage_keyclick from "./Employeemanage/keyclick";
import Employeemanage_setting from "./Employeemanage/setting";
import Employeemanage_moban_ui from "./Employeemanage/moban";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>


        <BrowserRouter>


            <Routes>

                <Route path={'/'} element={<Homepage/>}>

                    <Route path={'home_item1'} element={<Home_item1_UI/>}/>
                    <Route path={'home_soft_download'} element={<Home_soft_download/>}/>

                    <Route index element={<Home_item1_UI/>}/>

                </Route>


                <Route path="/admin" element={<Admin_Index_UI/>}>

                    <Route path="kuai_message" element={<SearchChain/>}/>

                    <Route path="chatmagin" element={<Admin_chatmagin/>}/>
                    <Route path="chatui" element={<ChatUi/>}/>
                    <Route path="keyclick" element={<Admin_keyclick/>}/>
                    <Route path="users" element={<SuperAdminUsers/>}/>
                    <Route path="account" element={<AccountUsage/>}/>
                    <Route path="commodity" element={<Admin_Commodity_ui/>}/>
                    <Route path="commodity_fenlei" element={<Commodity_fenlei_UI/>}/>
                    <Route path="commodity_list" element={<Commodity_list_UI/>}/>
                    <Route path="employeemanagement" element={<Navigate to="/admin/keyclick" replace/>}/>
                    <Route path="search" element={<Search_ui_index/>}/>
                    <Route path="moban" element={<Admin_moban_ui/>}/>
                    <Route path="knowledge_base" element={<Knowledge_base/>}>

                    </Route>

                    <Route path="detail" element={<Knowledge_detail/>}/>
                    <Route path="setting" element={<Admin_setting/>}/>
                    <Route path="client_update" element={<ClientUpdatePublisher/>}/>
                    <Route index element={<Admin_keyclick/>}/> {/* Default route */}
                </Route>



                <Route path={'/employeemanage'} element={<Employeemanage_Index_UI/>}>

                    <Route path="kuai_message" element={<Employeemanage_SearchChain/>}/>


                    <Route path="keyclick" element={<Employeemanage_keyclick/>}/>

                    <Route path="moban" element={<Employeemanage_moban_ui/>}/>


                    <Route path="setting" element={<Employeemanage_setting/>}/>
                    <Route index element={<Employeemanage_Index_UI/>}/> {/* Default route */}


                </Route>

                <Route path={'/userinfo'} element={<UserInfo_UI/>}>




                </Route>
                <Route path={'/buyvip'} element={<BuyVip_ui/>}></Route>

                <Route path={'/vipredemption'} element={<VipRedemption_UI/>}></Route>



                <Route path={'/login'} element={<Login_page_ad/>}></Route>





                <Route path={'/register'} element={<Register_index_ui/>}></Route>




                <Route path={'/useradmin'} element={<Useradmin_ui/>}></Route>


                <Route path={'/project'} element={<Project_Index_UI/>}>


                    <Route path="projectmanagement" element={<Project_projectmanagement/>}/>

                    <Route path="downloadmanagement" element={<Project_downloadmanagement/>}/>

                    <Route path="setting" element={<Project_setting/>}/>

                    <Route path="vipcard" element={<Project_vipcard/>}/>



                    <Route index element={<Project_projectmanagement/>}/> {/* Default route */}

                </Route>

                <Route path={'/projectlogin'} element={<Project_LoginForm/>}>


                    <Route index element={<Project_LoginForm/>}/> {/* Default route */}

                </Route>


            {/*    <Route path={'/admin'} element={<Dadmin/>}></Route>*/}
            </Routes>


        </BrowserRouter>

    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
